import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /prf\.hn/.test(hostname)
export const compactTracking = true

// Partnerize parses tracking params from path segments shaped like
// `/click/camref:X/pubref:Y/destination:URL`, not query strings — `?pubref=`
// is silently dropped. The value is URL-encoded because the underlying
// tracking string contains `/`, `|`, `=`, and `:`.
const setPubref = (url: URL, value: string): void => {
  const encoded = encodeURIComponent(value)
  const path = url.pathname
  if (/\/pubref:[^/]*/.test(path)) {
    url.pathname = path.replace(/\/pubref:[^/]*/, `/pubref:${encoded}`)
  } else if (path.includes('/destination:')) {
    url.pathname = path.replace('/destination:', `/pubref:${encoded}/destination:`)
  } else {
    url.pathname = `${path.replace(/\/$/, '')}/pubref:${encoded}`
  }
}

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    setPubref(url, params.trackingId)
    return
  }
  const value = params.content
    ? `co=${params.content}|${params.utmSearch}|t=${params.term}`
    : `${params.utmSearch}|t=${params.term}`
  setPubref(url, value)
}
